import classNames from 'classnames';

type Props =
    | {
          carriervalue: string;
          datawalink: string;
          islink: true;
      }
    | {
          carriervalue?: string;
          datawalink?: string;
          islink: false;
      };

const CarrierLogoWrapper = ({
    carriervalue,
    datawalink,
    islink,
    children,
    mobilesize,
    fullsize,
}: React.PropsWithChildren<
    Props & {
        mobilesize: string;
        fullsize: string;
    }
>) => {
    return (
        <div
            className={classNames(
                'flex flex-col justify-center items-center',
                'self-stretch flex-shrink-0',
                `w-${mobilesize}`,
                `md:w-${fullsize}`
            )}
        >
            {islink ? (
                <a
                    href={process.env.GATSBY_EHI_URL}
                    className="flex items-center justify-center"
                    data-filter={carriervalue}
                    data-wa-link={datawalink}
                >
                    {children}
                </a>
            ) : (
                <div className="flex items-center justify-center">{children}</div>
            )}
        </div>
    );
};

export default CarrierLogoWrapper;
